import React, { Component } from 'react';
import API from '../../../api/api';
import './detail.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button,message, Popconfirm, ConfigProvider } from 'antd';
class ChatSensitiveWords extends Component {

    constructor(props) {
        super(props);
        console.log('props.location.state.userId', props.location.state.userId,)
        this.state = {
            pagination: {
                hideOnSinglePage: true,
                showQuickJumper: false,
                showSizeChanger: false,
                addModalTitle: '',
                pageSize: 10,
                current: 1,
                total: 0,
                showTotal: total => `总${total}条`,
                position: 'top',
            },
            mainList: [
                // {
                //     userId: '1',
                //     rowId: '1',
                //     sWord:'几啊纠结啊',
                //     messageTypeDesc:'群聊',
                //     messageType:2,
                //     detail:'几啊纠结啊',
                //     sendTime:'2021-03-11 20:36:44',
                //     groupName:'ff',
                //     groupId:'2',
                //     isDismiss:'0',

                // },
                // {
                //     userId: '2',
                //     rowId: '2',
                //     userName: '躲猫猫吗',
                //     userImage: 'http://s1.im-dangdang.com/20210220/29b89c70-8f5e-4ad0-b322-4dfe12764cb5.jpg',
                //     registTime: "2021-03-11 20:36:44",
                //     wordList: [
                //         {
                //             word: '佛学',
                //             source: '秀客',
                //             sourceId: '1',
                //             sourceType: '9', // 0 广场 5 论坛  11 知道 9 秀客
                //         },
                //         {
                //             word: '佛学',
                //             source: '论坛',
                //             sourceId: '1',
                //             sourceType: '5', // 0 广场 5 论坛  11 知道 9 秀客
                //         },
                //         {
                //             word: '佛学',
                //             source: '知道',
                //             sourceId: '1',
                //             sourceType: '11', // 0 广场 5 论坛  11 知道 9 秀客
                //         },
                //     ]
                // }
            ],
            columns: [
                {
                    title: '敏感词名称',
                    dataIndex: 'sword',
                    key: 'sword',
                },
                {
                    title: '单/群/留言类别',
                    dataIndex: 'messageTypeDesc',
                    key: 'messageTypeDesc',
                },
                {
                    title: '内容详情',
                    dataIndex: 'detail',
                    key: 'detail',
                },
                {
                    title: '发送时间',
                    dataIndex: 'sendTime',
                    key: 'sendTime',
                },
                {
                    title: '群聊名称',
                    dataIndex: 'groupName',
                    key: 'groupName',
                },
                {
                    title: '接收用户ID',
                    dataIndex: 'toUserId',
                    key: 'toUserId',
                },
                {
                    title: '操作',
                    key: 'isFreeze',
                    render: (data) => (
                        <div className="operateBtnBlock">
                            {
                                data.messageType == 2 ?
                                    (data.isDismiss == '1' ?
                                        <div>已解散</div> :
                                        <Popconfirm title="确定解散该群吗？"
                                            onConfirm={this.deleteFuncOrDis.bind(this, data)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <Button key={'unFreezeBtn' + data.userId} type="primary" className="deleteBtn">解散</Button>
                                        </Popconfirm>
                                    ) : ''
                            }
                        </div>
                    ),
                },
            ],

            searchCondition: {
                pageNum: 10,
                pageSize: 1,
                userId: props.location.state.userId,
            }
        }
    }



    componentDidMount() {
        this.swMessageDetailList()
    }

    componentDidUpdate() {

    }


    async swMessageDetailList(type) {
        let { pagination, searchCondition } = this.state;
        if ('homePage' == type) {
            searchCondition.pageSize = 1
            pagination.current = 1
        }
        let result = await API.swMessageDetailList(searchCondition);
        if (result.status == 1) {
            let mainList = result.data.detailList;
            pagination.total = Number(result.data.totalNum);
            this.setState({
                pagination,
                mainList
            })
        }
    }


    async deleteFuncOrDis(data) {
        let result = await API.swMessageDismiss({
            groupId: data.groupId
        })
        if (result.status == 1) {
            message.success('解散成功');
            this.swMessageDetailList();
            return;
        }
        message.error(result.msg);
    }

    handleTableChange = (pagination) => {
        let { searchCondition } = this.state;
        console.log('pagination.current', pagination.current)
        if (pagination.current == 1) {
            searchCondition.pageSize = pagination.current
        } else {
            searchCondition.pageSize = pagination.current
        }
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
            searchCondition
        }, () => {
            this.swMessageDetailList();
        });
    };

    onShowSizeChange = (current, pageSize) => {
        let { searchCondition, pagination } = this.state;
        pagination.pageSize = pageSize
        pagination.current = 1
        searchCondition.pageNum = pageSize;
        searchCondition.pageSize = 1;
        this.setState({
            pagination,
            searchCondition
        }, () => {
            this.swMessageDetailList();
        });
    }




    goBack() {
        this.props.history.go(-1)
    }

    render() {
        const {
            columns,
            mainList,
            pagination,
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className={`chatSensitiveWordsDetail  `}>
                    <Button className='goBack' onClick={this.goBack.bind(this)}>返回</Button>
                    <Table columns={columns}
                        dataSource={mainList}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        onShowSizeChange={this.onShowSizeChange}
                        rowKey={(row, index) => row.userId + '-' + index}
                    />
                </div>
            </ConfigProvider>
        )
    }
}

export default ChatSensitiveWords;